// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1yX1g","signatureBlock":"Footer_signatureBlock__1FdqU","signature":"Footer_signature__1qKDv"};